import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "@/lib/agenda";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    (async () => {
      if (!m) { navigate("/login", { replace: true }); return; }
      try {
        const u = await authApi.googleSession(decodeURIComponent(m[1]));
        setUser(u);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center warm-canvas">
      <p className="text-sm text-slate-500">Entrando...</p>
    </div>
  );
}
